import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import queryStringLib from 'query-string';
import { ContextApp } from '../../context';
import MoviesList from '../movies-list';
import PaginationContainer from '../pagination';

const FilterMoviesListContainer = () => {
    const { state: { movies, queryString, searchFilter } } = useContext(ContextApp);
    const location = useLocation();
    const query = queryStringLib.parse(location.search,{arrayFormat: 'comma'});

    function getRangeForPagination(numPage) {
        return [numPage * 8 - 8, numPage * 8 + 0];
    }

    let countFilters = 0;

    for (let prop in queryString) {
        if (prop === 'page') {
            continue;
        }

        countFilters += queryString[prop].length;
    }

    if (countFilters > 0) {
        let filteredMovies = movies.filter((movie) => {
            let i = 0;
            let j = 0;

            const movieParameters = {};

            for (let prop in queryString) {
                if (prop === 'page') {
                    continue;
                }
                if (queryString[prop].length) {
                    j += 1;
                }
            }

            movie.parameters.forEach((filter) => {
                const [typeFilter, valueFilter] = filter.split('=');

                movieParameters[typeFilter] = valueFilter.split(',');
            });

            for (let prop in movieParameters) {
                if (prop === 'page') {
                    continue;
                }

                if (queryString[prop].some((parameter) => movieParameters[prop].includes(parameter))) {
                    i++;
                }
            }

            if (i === j) {
                return true;
            }

            return false;
        });

        if (searchFilter.length) {
            filteredMovies = filteredMovies.filter((movie) => movie.title.toLowerCase().includes(searchFilter));
        }

        if (filteredMovies.slice(...getRangeForPagination(query.page)).length === 0) {
            return <div className='filmik__no-content'>Ничего не найдено</div>;
        }

        return (
            <>
                <MoviesList movies={filteredMovies.slice(...getRangeForPagination(query.page))} />
                <PaginationContainer countMovies={filteredMovies.length} />
            </>
        );
    }

    let filteredMovies = [...movies];

    if (searchFilter.length) {
        filteredMovies = filteredMovies.filter((movie) => movie.title.toLowerCase().includes(searchFilter));
    }

    if (filteredMovies.length === 0) {
        return <div className='filmik__no-content'>Ничего не найдено</div>;
    }

    return (
        <>
            <MoviesList movies={filteredMovies.slice(...getRangeForPagination(query.page))} />
            <PaginationContainer countMovies={filteredMovies.length} />
        </>
    );
};

export default FilterMoviesListContainer;